<script lang="ts">
  export let restDaysWithActivity: number = 0; // number_forecasted_rest_days_with_activity
  export let totalRestDays: number | undefined; // number_forecasted_rest_days (optional)
  export let revealed: boolean = false;

  $: pct = totalRestDays && totalRestDays > 0
    ? Math.round((restDaysWithActivity / totalRestDays) * 100)
    : null;
</script>

<div class="relative w-[300px] h-[420px] rounded-2xl overflow-hidden border border-white/10 shadow-[0_0_30px_rgba(25,130,196,0.15)]">
  <!-- Solid layered background for better contrast -->
  <div class="absolute inset-0 bg-[linear-gradient(150deg,#0b1f2b_0%,#0e3344_50%,#0a2433_100%)]"></div>
  <div class="absolute inset-0 opacity-[0.08] bg-[repeating-linear-gradient(135deg,transparent_0_6px,rgba(255,255,255,0.8)_6px_7px,transparent_7px_13px)]"></div>
  <!-- Playful hotel door hanger that swings when revealed -->
  <div class="absolute -right-4 top-6 h-40 w-28 origin-top rounded-b-2xl bg-white/10 border border-white/20 backdrop-blur-sm shadow-[0_10px_30px_rgba(0,0,0,0.35)] flex items-start justify-center"
       class:hang-swing={revealed}>
    <div class="mt-5 text-off-white/90 flex flex-col items-center gap-1">
      <i class="fas fa-bed"></i>
      <span class="text-[10px] uppercase tracking-widest">Rest Day</span>
      <span class="text-[9px] opacity-70">Do Not Disturb</span>
    </div>
  </div>

  <!-- Subtle Zzz drifting up -->
  <div class="absolute left-6 bottom-1 text-off-white/50 pointer-events-none select-none">
    <span class="zz" aria-hidden="true">Z</span>
    <span class="zz delay-150" aria-hidden="true">z</span>
    <span class="zz delay-300" aria-hidden="true">z</span>
  </div>

  <!-- Content -->
  <div class="relative z-10 h-full w-full p-5 flex flex-col">
    <div class="flex-1">
      <div class="text-3xl font-bold montserrat max-w-[180px]">Rest… <br/>but make it active</div>
      <div class="mt-2 text-sm opacity-80 max-w-[180px]">You snuck in rides on rest days. We see you.</div>

      <div class="mt-6">
        <div class="text-6xl font-semibold tracking-tight">
          {restDaysWithActivity}
          <span class="text-base opacity-70 align-top ml-1">days</span>
        </div>
        {#if totalRestDays != null}
          <div class="mt-2 text-sm opacity-80">out of {totalRestDays} forecasted rest days</div>
        {:else}
          <div class="mt-2 text-sm opacity-80">on forecasted rest days</div>
        {/if}
      </div>
    </div>

    <!-- Footprints path along the bottom that animates in when revealed -->
    <div class="h-16 relative">
      <svg viewBox="0 0 300 64" class="absolute inset-0 w-full h-full">
        <defs>
          <linearGradient id="footGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stop-color="#1982C4"/>
            <stop offset="100%" stop-color="#5EE6E8"/>
          </linearGradient>
        </defs>
        <path class='opacity-0' d="M 10 48 C 60 8, 120 88, 170 30 S 260 44, 290 18" fill="none" stroke="url(#footGrad)" stroke-width="2" stroke-linecap="round" class:draw={revealed} />
      </svg>
    </div>
  </div>
</div>

<style>
  .hang-swing { animation: swing 1400ms ease-in-out 200ms 1 both; }
  @keyframes swing {
    0% { transform: rotate(0deg); }
    20% { transform: rotate(8deg); }
    45% { transform: rotate(-6deg); }
    65% { transform: rotate(3deg); }
    85% { transform: rotate(-1.5deg); }
    100% { transform: rotate(0deg); }
  }

  .zz { position: relative; display: inline-block; font-weight: 700; }
  .zz::after { content: 'z'; position: absolute; left: 0; top: 0; opacity: 0.2; }
  .zz { animation: drift 4s ease-in-out infinite; }
  .zz.delay-150 { animation-delay: 150ms; }
  .zz.delay-300 { animation-delay: 300ms; }
  @keyframes drift {
    0% { transform: translateY(0) translateX(0); opacity: 0; }
    20% { opacity: 1; }
    70% { opacity: 1; }
    100% { transform: translateY(-22px) translateX(6px); opacity: 0; }
  }

  .draw { opacity: 1 !important; stroke-dasharray: 460; stroke-dashoffset: 460; animation: pathdraw 1400ms ease-out 300ms forwards; }
  @keyframes pathdraw { to { stroke-dashoffset: 0; } }
</style>
